import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Edit16 = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M13.4 5.6L5.8 13.2L2 14L2.8 10.2L10.4 2.6C11.2 1.8 12.6 1.8 13.4 2.6C14.2 3.5 14.2 4.8 13.4 5.6Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
